import {
  CLM_FREE_DATA,
  CLM_SET_CLAIMS_LOADING_STATE,
  CLM_SET_CURRENT_CLAIM,
  CLM_GET_CLAIM_STATUS_LIST,
  CLM_GET_CLAIM_TYPES_LIST,
  CLM_SET_CLAIMS_FILTER,
  CLM_CLEAR_CLAIMS_LIST,
  CLM_GET_CLAIMS_LIST, // Получение списка запросов на КП, согласно установленному текущему фильтру
  CLM_CREATE_CLAIM,
  CLM_CANCEL_CLAIM,
  CLM_POST_CLAIM,
  CLM_ADD_FILE,
  CLM_DEL_FILE,
  CLM_CHANGE_COMMENT,
  CLM_DELETE_COMMENT,
  CLM_DATA_LONGPOLL,
  CLM_READ_CLAIM

} from '../actions/claims'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR, UI_ALLOW_LONGPOLL } from '../actions/ui'
import axios from 'axios'
const state = {
  currentClaim: {},
  claimList: [],
  claimStatesList: [],
  claimTypesList: [],
  currentClaimsFilter: { DS_ID: null, DT_ID: null },
  claimListLoading: false,
  claimsLPData: []
}

const getters = {
  getCurrentClaim: state => state.currentClaim,
  getCurrentClaimAvailReports: state => state.currentClaim.AVAIL_REPORTS,
  getCurrentClaimsList: state => state.claimList,
  getClaimStatesList: state => state.claimStatesList,
  getClaimTypesList: state => state.claimTypesList,
  getClaimListLoading: state => state.claimListLoading,
  getCurrentClaimsFilter: state => state.currentClaimsFilter,
  getClaimsLPData: state => state.claimsLPData
}

const actions = {
  [CLM_FREE_DATA]: ({ commit, dispatch }) =>
    new Promise((resolve) => {
      dispatch(UI_ALLOW_LONGPOLL, 'off')
      commit(CLM_FREE_DATA)
      resolve('success')
    }),
  [CLM_GET_CLAIM_STATUS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_GET_CLAIM_STATUS_LIST', topic: 'Загрузка списка статусов запросов', error: null })
      commit(CLM_SET_CLAIMS_LOADING_STATE, true)
      axios({ url: '/api/claims/getClaimsStatusList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_GET_CLAIM_STATUS_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CLM_GET_CLAIM_STATUS_LIST' })
            resolve(resp.data.data)
          } else {
            console.log('Claim status list request error: ', resp.data.error_text)
            dispatch(UI_ERROR, { action: 'CLM_GET_CLAIM_STATUS_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_GET_CLAIM_STATUS_LIST', result: 'Получение списка возможных статусов документа: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(CLM_SET_CLAIMS_LOADING_STATE, false)
        })
    }),
  [CLM_GET_CLAIM_TYPES_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_GET_CLAIM_TYPES_LIST', topic: 'Загрузка списка типов запросов', error: null })
      console.log('Claim types list action initiated')
      commit(CLM_SET_CLAIMS_LOADING_STATE, true)
      axios({ url: '/api/claims/getClaimTypesList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'CLM_GET_CLAIM_TYPES_LIST' })
            commit(CLM_GET_CLAIM_TYPES_LIST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CLM_GET_CLAIM_TYPES_LIST', result: resp.data.error_text })
            console.log('Claim status list request error: ', resp.data.error_text)
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_GET_CLAIM_TYPES_LIST', result: 'Получение списка возможных статусов документа: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(CLM_SET_CLAIMS_LOADING_STATE, false)
        })
    }),

  [CLM_GET_CLAIMS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_GET_CLAIMS_LIST', topic: 'Загрузка списка запросов', error: null })
      console.log('Called action CLM_GET_CLAIMS_LIST, current filter is  ', state.currentClaimsFilter)
      commit(CLM_CLEAR_CLAIMS_LIST)
      const filterSet = !(state.currentClaimsFilter.DS_ID === null) && !(state.currentClaimsFilter.DT_ID === null)
      if (!filterSet) {
        reject(new Error('Не установлен фильтр состояний'))
        dispatch(UI_ERROR, { action: 'CLM_GET_CLAIMS_LIST', result: 'Не установлен фильтр состояний' })
        return
      }
      commit(CLM_SET_CLAIMS_LOADING_STATE, true)
      axios({ url: '/api/claims/getClaimsListNew.php', data: state.currentClaimsFilter, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_GET_CLAIMS_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CLM_GET_CLAIMS_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CLM_GET_CLAIMS_LIST', result: 'Ошибка получения списка возможных статусов запроса: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_GET_CLAIMS_LIST', result: 'Получение списка возможных состояний: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(CLM_SET_CLAIMS_LOADING_STATE, false)
        })
    }),
  [CLM_SET_CLAIMS_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action CLM_SET_CLAIMS_FILTER] ', filterItem)
      dispatch(UI_REQUEST, { action: 'CLM_SET_CLAIMS_FILTER', topic: 'Установка фильтра запросов', error: null })
      if (filterItem.DS_ID !== null && filterItem.DT_ID !== null) {
        if (filterItem.DS_ID !== state.currentClaimsFilter.DS_ID || filterItem.DT_ID !== state.currentClaimsFilter.DT_ID) {
          commit(CLM_SET_CLAIMS_FILTER, filterItem)
          commit(CLM_CLEAR_CLAIMS_LIST)
          dispatch(CLM_GET_CLAIMS_LIST)
            .then(resp => {
              dispatch(UI_SUCCESS, { action: 'CLM_SET_CLAIMS_FILTER' })
              resolve(resp)
            })
            .catch((err) => {
              dispatch(UI_ERROR, { action: 'CLM_SET_CLAIMS_FILTER', result: 'Установка фильтра запросов: ошибка сервера' })
              reject(err)
            })
        } else {
          dispatch(UI_SUCCESS, { action: 'CLM_SET_CLAIMS_FILTER' })
          resolve(filterItem)
        }
      } else {
        commit(CLM_SET_CLAIMS_FILTER, filterItem)
        dispatch(UI_SUCCESS, { action: 'CLM_SET_CLAIMS_FILTER' })
        resolve(filterItem)
      }
    }),

  [CLM_SET_CURRENT_CLAIM]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action CLM_SET_CURRENT_CLAIM ', requestItem)
      dispatch(UI_REQUEST, { action: 'CLM_SET_CURRENT_CLAIM', topic: 'Установка активного запроса', error: null })
      if (requestItem) {
        if (requestItem.DOC_ID !== state.currentClaim.DOC_ID) {
          console.log('Setting new current request', requestItem)
          commit(CLM_SET_CURRENT_CLAIM, requestItem)
          dispatch(CLM_READ_CLAIM, requestItem)
        }
      } else {
        commit(CLM_SET_CURRENT_CLAIM, {})
      }
      dispatch(UI_SUCCESS, { action: 'CLM_SET_CURRENT_CLAIM' })
      resolve([])
    }),
  [CLM_READ_CLAIM]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_READ_CLAIM', topic: 'Обновление активного запросов', error: null })
      axios({ url: '/api/claims/readClaim.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'CLM_READ_CLAIM' })
            commit(CLM_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CLM_READ_CLAIM', result: 'Обновление запроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_READ_CLAIM', result: 'Обновление запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [CLM_CREATE_CLAIM]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_CREATE_CLAIM', topic: 'Создание запроса', error: null })
      axios({ url: '/api/claims/createNewClaim.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_CREATE_CLAIM, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CLM_CREATE_CLAIM' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CLM_CREATE_CLAIM', result: 'Создание запроса: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_CREATE_CLAIM', result: 'Создание запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CLM_CANCEL_CLAIM]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_CANCEL_CLAIM', topic: 'Отмена запроса', error: null })
      console.log('CLM_CANCEL_CLAIM action called')
      dispatch(CLM_POST_CLAIM, params)
        .then(resp => {
          console.log('CLM_POST_CLAIM returned responce to CLM_CANCEL_CLAIM', resp)
          if (resp.error === 'ok') {
            console.log('CLM_CANCEL_CLAIM result is OK, commiting CLM_CANCEL_CLAIM mutation')
            commit(CLM_CANCEL_CLAIM, params)
            resolve()
            dispatch(UI_SUCCESS, { action: 'CLM_CANCEL_CLAIM' })
          } else {
            dispatch(UI_ERROR, { action: 'CLM_CANCEL_CLAIM', result: 'Обновление данных по состоянию запроса: ошибка сервера' })
            reject(new Error(resp.error_text))
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_CANCEL_CLAIM', result: 'Обновление данных по состоянию запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CLM_POST_CLAIM]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_POST_CLAIM', topic: 'Изменение состояния запроса', error: null })
      axios({ url: '/api/claims/postClaim.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_POST_CLAIM, params)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'CLM_POST_CLAIM' })
          } else {
            dispatch(UI_ERROR, { action: 'CLM_POST_CLAIM', result: 'Ошибка отправки запроса : ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_POST_CLAIM', result: 'Ошибка отправки запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CLM_ADD_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_ADD_FILE', topic: 'Добавление файла в запрос', error: null })
      axios({ url: '/api/claims/uploadClaimDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_ADD_FILE, resp.data.data)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'CLM_ADD_FILE' })
          } else {
            dispatch(UI_ERROR, { action: 'CLM_ADD_FILE', result: 'Ошибка добавления файла в запрос: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_ADD_FILE', result: 'Добавление данных в запрос: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CLM_DEL_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_DEL_FILE', topic: 'Удаление файла из запроса', error: null })
      axios({ url: '/api/claims/delClaimFile.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_DEL_FILE, params)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'CLM_DEL_FILE' })
          } else {
            dispatch(UI_ERROR, { action: 'CLM_DEL_FILE', result: 'Удаление файла из запроса КП: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_DEL_FILE', result: 'Удаление файла из запроса КП: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CLM_CHANGE_COMMENT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_CHANGE_COMMENT', topic: 'Изменение комментария запроса', error: null })
      axios({ url: '/api/claims/updClaimComment.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CLM_CHANGE_COMMENT' })
          } else {
            dispatch(UI_ERROR, { action: 'CLM_CHANGE_COMMENT', result: 'Ошибка обновления данных в запросе: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_CHANGE_COMMENT', result: 'Обновление данных в запросе на КП: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CLM_DELETE_COMMENT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CLM_DELETE_COMMENT', topic: 'Удаление комментария запроса', error: null })
      axios({ url: '/api/claims/delClaimComment.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CLM_DELETE_COMMENT' })
          } else {
            dispatch(UI_ERROR, { action: 'CLM_DELETE_COMMENT', result: 'Ошибка обновления данных в запросе на КП: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CLM_DELETE_COMMENT', result: 'Обновление данных в запросе на КП: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [CLM_DATA_LONGPOLL]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      axios({ url: '/api/claims/getClaimsData.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CLM_DATA_LONGPOLL, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ALLOW_LONGPOLL, 'off')
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ALLOW_LONGPOLL, 'off')
          reject(new Error(err))
        })
    })
}

const mutations = {

  [CLM_FREE_DATA]: state => {
    state.currentClaim = {}
    state.claimList.splice(0, state.claimList.length)
    state.claimStatesList.splice(0, state.claimStatesList.length)
    state.claimTypesList.splice(0, state.claimTypesList.length)
    state.currentClaimsFilter = { DS_ID: null, DT_ID: null }
    state.claimListLoading = false
  },
  [CLM_GET_CLAIM_STATUS_LIST]: (state, resp) => {
    console.log('CLM_GET_CLAIM_STATUS_LIST mutation initiated, ', resp)
    state.claimStatesList = resp
  },
  [CLM_GET_CLAIM_TYPES_LIST]: (state, resp) => {
    console.log('CLM_GET_CLAIM_TYPES_LIST mutation initiated, ', resp)
    state.claimTypesList = resp
  },
  [CLM_CLEAR_CLAIMS_LIST]: (state) => {
    console.log('CLM_CLEAR_CLAIMS_LIST mutation initiated, ')
    state.claimList.splice(0, state.claimList.length)
  },
  [CLM_GET_CLAIMS_LIST]: (state, resp) => {
    console.log('CLM_GET_CLAIMS_LIST mutation initiated, ', resp)
    state.claimList = resp
    state.currentClaim = {}
  },
  [CLM_SET_CLAIMS_FILTER]: (state, resp) => {
    console.log('CLM_SET_CLAIMS_FILTER mutation initiated, ', resp)
    state.currentClaimsFilter = resp
  },
  [CLM_SET_CLAIMS_LOADING_STATE]: (state, resp) => {
    console.log('CLM_SET_CLAIMS_LOADING_STATE mutation initiated, ', resp)
    state.claimListLoading = resp
  },
  [CLM_SET_CURRENT_CLAIM]: (state, resp) => {
    console.log('CLM_SET_CURRENT_CLAIM mutation initiated, ', resp)
    state.currentClaim = resp
  },
  [CLM_CREATE_CLAIM]: (state, orderItem) => {
    console.log('CLM_CREATE_CLAIM mutation initiated', orderItem)
    // Проверяем, является ли текущий фильтр запросов соответствующим состоянию нового запроса
    if (
      // eslint-disable-next-line eqeqeq
      (state.currentClaimsFilter.DS_ID == orderItem.DS_ID || state.currentClaimsFilter.DS_ID == -5) &&
      // eslint-disable-next-line eqeqeq
      (state.currentClaimsFilter.DT_ID == orderItem.DT_ID || state.currentClaimsFilter.DT_ID == -5)
    ) {
      // Если да, то добавляем новый запрос в глобальный список запросов
      state.claimList.unshift(orderItem)
    }
  },
  [CLM_CANCEL_CLAIM]: (state, resp) => {
    console.log('CLM_CANCEL_CLAIM mutation called. RESP is ', resp)
    const clmIndex = state.claimList.findIndex(clm => clm.DOC_ID === resp.DOC_ID)
    if (clmIndex !== -1) {
      state.claimList.splice(clmIndex, 1)
    }
  },
  [CLM_POST_CLAIM]: (state, resp) => {
    console.log('CLM_POST_CLAIM mutation called. RESP is ', resp)
    const clmItemIdx = state.claimList.findIndex(clm => clm.DOC_ID === resp.DOC_ID)
    console.log('CLM_POST_CLAIM found item index ', clmItemIdx)
    if (clmItemIdx !== -1) {
      console.log('CLM_POST_CLAIM: item conversion ', clmItemIdx)
      resp.PTC === 'type' ? state.claimList[clmItemIdx].DT_ID = resp.SIGNAL_ID : state.claimList[clmItemIdx].DS_ID = resp.SIGNAL_ID
      console.log('CLM_POST_CLAIM: current filter is ', state.currentClaimsFilter)
      console.log('CLM_POST_CLAIM: found item is ', state.claimList[clmItemIdx])
      if (
        // eslint-disable-next-line eqeqeq
        (state.currentClaimsFilter.DS_ID != state.claimList[clmItemIdx].DS_ID && state.currentClaimsFilter.DS_ID != -5) ||
        // eslint-disable-next-line eqeqeq
        (state.currentClaimsFilter.DT_ID != state.claimList[clmItemIdx].DT_ID && state.currentClaimsFilter.DT_ID != -5)
      ) {
        console.log('CLM_POST_CLAIM: item remove ', state.claimList[clmItemIdx])
        // Если да, то убираем запрос из глобального списка запросов
        state.claimList.splice(clmItemIdx, 1)
        state.currentClaim = {}
      }
    }
  },
  [CLM_ADD_FILE]: (state, responce) => {
    console.log('CLM_ADD_FILE mutation called, payload ', responce)
    state.currentClaim.FILE_LIST.push(responce)
  },
  [CLM_DEL_FILE]: (state, responce) => {
    console.log('CLM_DEL_FILE mutation called, payload ', responce)
    const index = state.currentClaim.FILE_LIST.findIndex(itm => itm.DD_ID === responce.DD_ID)
    state.currentClaim.FILE_LIST.splice(index, 1)
  },
  [CLM_CHANGE_COMMENT]: (state, responce) => {
    console.log('CLM_CHANGE_COMMENT mutation called, payload ', responce)
    state.currentClaim.COMMENTS_TAB.splice(0, state.currentClaim.COMMENTS_TAB.length, ...responce)
  },
  [CLM_DATA_LONGPOLL]: (state, responce) => {
    console.log('CLM_DATA_LONGPOLL mutation called, payload ', responce)
    state.claimsLPData = responce
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
